import { createContext, FC, useContext, useCallback, useEffect, useState, useReducer, useRef, useMemo } from 'react';
import useFetchAllDimAndAttributeTypes from 'hooks/Filter/useFetchDimAndAttrType';
import useFetchTimePeriodFilter from 'hooks/Filter/useFetchTimePeriod';
import {
    allDimAndAttributeTypeObjectTOListOfAttributeTypeArray,
    applyFilterObjectAdd,
    dimAndAttributeFormater,
    getApplyFilterObject,
    initializeApplyFilter,
    initializeSelectAllValues,
    changePeriodAccordingToScreen,
    initialize,
    getFilteredApplyFilterObject,
    initializeAllSelectedObject,
    createDefaultFilterObject,
} from 'parser/filterParser';
import { UserContext } from './ConfigContext';
import { getConfig, sendNotification } from 'utils/helperMethods';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';
import { callId, createFilterB } from 'components/molecules/Filter/FilterApplyButton';
import { useDownloadAllAttributeNames } from 'hooks/Filter/useDownloadAllAttributeNames';
import { useLocation, useNavigate } from 'react-router-dom';
import { cloneDeep, isEmpty } from 'lodash';
import useFetchSinglePreset from 'hooks/Filter/useFetchSinglePreset';
import useGetMaxTimeStamps from 'hooks/general/useGetMaxTimeStamps';
import { CurrentFrequency } from 'types/common';
import { dayType } from 'utils/Calender';
import useTierList from 'hooks/pricingPool/useTierList';
import { isPpaPerfSummaryScreen, PPA_HOME_ROUTE, PPA_PERF_SUMMARY_SCREEN } from 'config/urls';
import {
    buildGlobalFilterUiStateFromPersistedScope,
    hasPersistedUserScope,
    mergeApplyFilterObjects,
} from 'hooks/ppa/ppaScope.helpers';

const isPpaHomePath = (pathname: string) => pathname.includes(PPA_HOME_ROUTE);

const FilterContextData = createContext<{
    allDimAndAttributeType: any;
    setAllDimAndAttributeType: Function;
    allAttributeNames: any;
    setAllAttributeNames: Function;
    allCheckedAttribute: any;
    setAllCheckedAttribute: Function;
    recentIdFromAttributeSelection: any;
    setRecentIdFromAttributeSelection: Function;
    applyFilterButtonObject: any;
    idForRestOfComponent: any;
    setIdForRestOfComponent: Function;
    previousSelectedAttributesInUI: any;
    setPreviousSelectedAttributesInUI: Function;
    allDimAndAttributeTypeList: any;
    setAllDimAndAttributeTypeList: Function;
    applyFilterObject: any;
    setApplyFilterObject: Function;
    allSelectedValueForAllAttribute: any;
    setAllSelectedValueForAllAttribute: Function;
    timePeriodSelection: any;
    setTimePeriodSelection: Function;
    idForRestOfComponentLoading: boolean;
    setIdForRestOfComponentLoading: Function;
    ppaScopeFilterLoading: boolean;
    setPpaScopeFilterLoading: Function;
    ppaScopeFilterIds: any;
    setPpaScopeFilterIds: Function;
    ppaGlobalFilterApplied: boolean;
    setPpaGlobalFilterApplied: Function;
    ppaPersistedScope: Record<string, unknown> | null;
    setPpaPersistedScope: Function;
    idForRestOfComponentFilterB: any;
    setIdForRestOfComponentFilterB: Function;
    loadingForAllCheckAttribute: Boolean;
    setLoadingForAllCheckAttribute: Function;
    timePeriodLoading: boolean;
    recentIdFromAttributeSelectionRef: any;
    timePeriodList: any;
    filterNullError: string;
    setFilterNullError: Function;
    filterBLoading: any;
    setFilterBLoading: Function;
    setTimePeriodList: Function;
    timeSelectionLabel: any;
    setTimeSelectionLabel: Function;
    setLatestUpdatedDate: Function;
    latestDate: null | string;
    visibleDatePicker: boolean;
    setVisibleDatePicker: Function;
    expandFilterBol: boolean;
    setExpandFilterBol: Function;
    presetsFilterObj: any;
    selectedPresetInfoObj: { label: string; value: string; isDefault: boolean };
    setSelectedPresetInfoObj: Function;
    fetchSinglePresetWrapper: Function;
    applyGlobalFilterHandler: Function;
    isGlobalFilterDisabled: boolean;
    disablePresetFilter: boolean;
    setIsGlobalFilterDisabled: Function;
    attributeTypes: any;
    screenFilterConfig: any;
    maxTimeStampData: any;
    maxTimeStampLoading: boolean;
    maxTimeStampError: any;
    screenName: string;
    hideGlobalTimeFilterComponent: boolean; // flag to hide the time period component in the global filter
    setHideGlobalTimeFilterComponent: Function;
    currentFrequency: CurrentFrequency;
    availableFrequencies: string[];
    calenderStartDay: dayType;
    showTierFilter: boolean;
    multiSelectedTiers: string[];
    setMultiSelectedTiers: Function;
    singleSelectedTier: string[];
    setSingleSelectedTier: Function;
    profitPoolTierList: any[];
    isTiersSingleSelect: boolean;
    setIsTiersSingleSelect: Function;
    tempMultiSelectedTiers: string[];
    setTempMultiSelectedTiers: Function;
    tempSingleSelectedTier: string[];
    setTempSingleSelectedTier: Function;
    closeTierFilter: boolean;
    setCloseTierFilter: Function;
    isGlobalFilterCollapsed: boolean;
    setIsGlobalFilterCollapsed: Function;
}>({
    allDimAndAttributeType: {},
    setAllDimAndAttributeType: () => {},
    allAttributeNames: {},
    setAllAttributeNames: () => {},
    allCheckedAttribute: {},
    setAllCheckedAttribute: () => {},
    recentIdFromAttributeSelection: {},
    setRecentIdFromAttributeSelection: () => {},
    applyFilterButtonObject: {},
    idForRestOfComponent: {},
    setIdForRestOfComponent: () => {},
    previousSelectedAttributesInUI: {},
    setPreviousSelectedAttributesInUI: () => {},
    allDimAndAttributeTypeList: {},
    setAllDimAndAttributeTypeList: () => {},
    applyFilterObject: {},
    setApplyFilterObject: () => {},
    allSelectedValueForAllAttribute: {},
    setAllSelectedValueForAllAttribute: () => {},
    timePeriodSelection: {},
    setTimePeriodSelection: () => {},
    idForRestOfComponentLoading: false,
    setIdForRestOfComponentLoading: () => {},
    ppaScopeFilterLoading: false,
    setPpaScopeFilterLoading: () => {},
    ppaScopeFilterIds: { dim1: { ids: [] }, dim2: { ids: [] } },
    setPpaScopeFilterIds: () => {},
    ppaGlobalFilterApplied: false,
    setPpaGlobalFilterApplied: () => {},
    ppaPersistedScope: null,
    setPpaPersistedScope: () => {},
    idForRestOfComponentFilterB: {},
    setIdForRestOfComponentFilterB: () => {},
    loadingForAllCheckAttribute: true,
    setLoadingForAllCheckAttribute: () => {},
    timePeriodLoading: false,
    recentIdFromAttributeSelectionRef: {},
    timePeriodList: [],
    filterNullError: '',
    setFilterNullError: () => {},
    filterBLoading: '',
    setFilterBLoading: () => {},
    setTimePeriodList: () => {},
    timeSelectionLabel: '',
    setTimeSelectionLabel: () => {},
    setLatestUpdatedDate: () => {},
    latestDate: null,
    visibleDatePicker: false,
    setVisibleDatePicker: () => {},
    expandFilterBol: false,
    setExpandFilterBol: () => {},
    presetsFilterObj: {},
    selectedPresetInfoObj: { label: '', value: '', isDefault: false },
    setSelectedPresetInfoObj: () => {},
    fetchSinglePresetWrapper: () => {},
    applyGlobalFilterHandler: () => {},
    isGlobalFilterDisabled: false,
    disablePresetFilter: false,
    setIsGlobalFilterDisabled: () => {},
    attributeTypes: {},
    screenFilterConfig: {},
    maxTimeStampData: undefined,
    maxTimeStampLoading: false,
    maxTimeStampError: null,
    screenName: '',
    hideGlobalTimeFilterComponent: false,
    setHideGlobalTimeFilterComponent: () => {},
    currentFrequency: {},
    availableFrequencies: [],
    calenderStartDay: 'Monday',
    showTierFilter: false,
    multiSelectedTiers: [],
    setMultiSelectedTiers: () => {},
    singleSelectedTier: [],
    setSingleSelectedTier: () => {},
    profitPoolTierList: [],
    isTiersSingleSelect: false,
    setIsTiersSingleSelect: () => {},
    tempMultiSelectedTiers: [],
    setTempMultiSelectedTiers: () => {},
    tempSingleSelectedTier: [],
    setTempSingleSelectedTier: () => {},
    closeTierFilter: false,
    setCloseTierFilter: () => {},
    isGlobalFilterCollapsed: false,
    setIsGlobalFilterCollapsed: () => {},
});

interface props {
    children: React.ReactNode;
}

type screenConfig = {
    screenName: null | string;
    globalTimePeriodKey: null | string;
    maxTimestampsKey: null | string;
};

const initialSelectedPresetInfoObj = { label: '', value: '', isDefault: false };

const FilterContext: FC<props> = ({ children }) => {
    let route = useLocation();
    const { appConfig } = useContext(UserContext);
    const globalFilterConfig = getConfig('globalFilter', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const profitPoolConfig = getConfig('profitPool', appConfig);
    const globalFilterChangingRoutes = globalFilterConfig?.globalFilterChangingRoutes;
    const retainFiltersAcrossFeatures = globalFilterConfig?.retainFiltersAcrossFeatures;
    const availableFrequenciesList = globalFilterConfig?.availableFrequenciesList;
    const defaultTierFilterSelections = profitPoolConfig?.defaultTierFilterSelections || {
        multiSelect: [],
        singleSelect: [],
    };

    //checking screen name
    const previousRouteName = useRef<any>();

    //check if default preset is fetched
    //will turn true once default preset api call is triggered
    const isDefaultPresetFetched = useRef(false);
    // Tracks when global filter bootstrap was skipped on PPA home for lazy init on navigation away
    const globalFilterDeferredRef = useRef(isPpaHomePath(route.pathname));

    const screenName = route.pathname?.slice(route.pathname?.lastIndexOf('/') + 1);
    const isPpaHomeRoute = isPpaHomePath(route.pathname);

    const previousScreenName = previousRouteName.current
        ? previousRouteName.current?.slice(previousRouteName.current?.lastIndexOf('/') + 1)
        : '';
    const screenFilterConfig = useMemo(() => {
        return globalFilterChangingRoutes?.[screenName];
    }, [screenName]);
    const currentScreenFeatureName = useMemo(() => {
        return screenFilterConfig?.dimensionListKey || 'default';
    }, [screenFilterConfig]);
    const defaultGlobalFilterFromConfig = screenFilterConfig
        ? screenFilterConfig?.defaultGlobalFilterObj || globalFilterConfig?.PromoScoreCardDefaultObj
        : globalFilterConfig?.PromoScoreCardDefaultObj;

    // state to disable global filter
    const [isGlobalFilterDisabled, setIsGlobalFilterDisabled] = useState(false);
    const [hideGlobalTimeFilterComponent, setHideGlobalTimeFilterComponent] = useState(false);
    const [attributeTypes, setAttributeTypes] = useState({});
    const [disablePresetFilter, setDisablePresetFilter] = useState(isPresetFilterEnabled());
    const [allDimAndAttributeType, setAllDimAndAttributeType] = useState<any>({ dimentions: [], loading: true });
    const [expandFilterBol, setExpandFilterBol] = useState(true);
    const [allAttributeNames, setAllAttributeNames] = useState<any>({});
    const [allCheckedAttribute, setAllCheckedAttribute] = useState<any>({});
    const [recentIdFromAttributeSelection, setRecentIdFromAttributeSelection] = useState<any>({});
    const recentIdFromAttributeSelectionRef = useRef({});
    const applyFilterButtonObject = useRef({});
    const [calenderStartDay, setCalenderStartDay] = useState(commonConfig?.calenderStartDay);
    //set default time period list
    const [timePeriodList, setTimePeriodList] = useState<any>([]);
    const [idForRestOfComponent, setIdForRestOfComponent] = useState({
        dim1: { ids: [] },
        dim2: { ids: [] },
    });
    const [idForRestOfComponentLoading, setIdForRestOfComponentLoading] = useState(true);
    const [ppaScopeFilterLoading, setPpaScopeFilterLoading] = useState(false);
    const [ppaScopeFilterIds, setPpaScopeFilterIds] = useState({
        dim1: { ids: [] },
        dim2: { ids: [] },
    });
    const [ppaGlobalFilterApplied, setPpaGlobalFilterApplied] = useState(false);
    const [ppaPersistedScope, setPpaPersistedScope] = useState<Record<string, unknown> | null>(null);
    const isPpaPerformanceSummaryRoute = isPpaPerfSummaryScreen(screenName);

    //use from config appconfig key - (defaultIdObject) : TODO
    const [previousSelectedAttributesInUI, setPreviousSelectedAttributesInUI] = useState({
        dim1: ['attr', 'attr'],
        dim2: ['attr', 'attr'],
        dim3: ['attr', 'attr'],
        dim4: ['attr', 'attr'],
    });
    const [allDimAndAttributeTypeList, setAllDimAndAttributeTypeList] = useState({ dimentions: [], loading: true });
    const [applyFilterObject, setApplyFilterObject] = useState<any>({});
    const [allSelectedValueForAllAttribute, setAllSelectedValueForAllAttribute] = useState({});
    const [timePeriodSelection, setTimePeriodSelection] = useState<any>();
    const {
        data,
        loading,
        error: fetchAllAttributeTypesError,
        callAllAttributeType,
        setLoading: setFetchAllAttributeTypesLoading,
    } = useFetchAllDimAndAttributeTypes({ currentScreenFeatureName });

    const [idForRestOfComponentFilterB, setIdForRestOfComponentFilterB] = useState({
        dim1: { ids: [] },
        dim2: { ids: [] },
    });
    const previousApplyFilterObjectRef = useRef<any>({});
    const [loadingForAllCheckAttribute, setLoadingForAllCheckAttribute] = useState(true);
    const [filterNullError, setFilterNullError] = useState<any>();
    const [filterBLoading, setFilterBLoading] = useState<any>(false);
    const [timeSelectionLabel, setTimeSelectionLabel] = useState('');
    const [latestDate, setLatestDate] = useState<null | string>(null);
    const [visibleDatePicker, setVisibleDatePicker] = useState(false);

    //PRESETS
    const [presetsFilterObj, setPresetsFilterObj] = useState<any>(); //stores the preset filter object (data structure remains same as default filter object)
    const [selectedPresetInfoObj, setSelectedPresetInfoObj] = useState({ ...initialSelectedPresetInfoObj }); //this will have info like preset name, is the preset default(true/false)

    // current frequency - monthly / weekly / quarterly
    const [currentFrequency, setCurrentFrequency] = useState<CurrentFrequency>({});
    const [availableFrequencies, setAvailableFrequencies] = useState<string[]>([]);

    const showTierFilter = useMemo(() => route.pathname.includes('/profit-pool/'), [route.pathname]);

    const [tempMultiSelectedTiers, setTempMultiSelectedTiers] = useState<string[]>(
        defaultTierFilterSelections.multiSelect,
    );
    const [tempSingleSelectedTier, setTempSingleSelectedTier] = useState<string[]>(
        defaultTierFilterSelections.singleSelect,
    );
    const [multiSelectedTiers, setMultiSelectedTiers] = useState<string[]>(defaultTierFilterSelections.multiSelect);
    const [singleSelectedTier, setSingleSelectedTier] = useState<string[]>(defaultTierFilterSelections.singleSelect);
    const [profitPoolTierList, setProfitPoolTierList] = useState<any[]>([]);
    const [isTiersSingleSelect, setIsTiersSingleSelect] = useState(false);
    const [closeTierFilter, setCloseTierFilter] = useState(false);
    const [isGlobalFilterCollapsed, setIsGlobalFilterCollapsed] = useState(false);

    useEffect(() => {
        const isTierSingleSelect = profitPoolConfig?.singleSelectTierEnabledRoutes?.some((_route: string) =>
            route?.pathname.includes(_route),
        );
        setIsTiersSingleSelect(isTierSingleSelect);
    }, [route.pathname]);

    const { data: tierListData, loading: tierListLoading } = useTierList(showTierFilter);

    useEffect(() => {
        if (!tierListLoading && !isEmpty(tierListData?.getTierList)) {
            const allTiersList = tierListData?.getTierList.map((tier: any) => tier.tierReference);
            allTiersList.sort();
            setProfitPoolTierList(tierListData?.getTierList);
            setMultiSelectedTiers(allTiersList);
            setSingleSelectedTier([allTiersList[0]]);
        }
    }, [tierListData, tierListLoading]);

    const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);

    const { functionTOCallAllAttributeName, loading: allAttributeLoading } = useDownloadAllAttributeNames({
        setAllCheckedAttribute,
    });
    const {
        data: timePeriodFilter,
        allFrequencies: timePeriodFilterFrequencies,
        setData: setTimePeriodFilter,
        error: timePeriodFilterError,
        loading: timePeriodFilterLoading,
        fetchTimePeriodFilter,
    } = useFetchTimePeriodFilter();
    let {
        data: maxTimeStampData,
        loading: maxTimeStampLoading,
        getMaxTimeStampsCall,
        error: maxTimeStampError,
    } = useGetMaxTimeStamps();

    const {
        loading: singlePresetFetchLoading,
        fetchSinglePreset,
        setLoading: setSinglePresetLoading,
    } = useFetchSinglePreset({
        onComplete: onPresetFetchComplete,
        onError: onPresetFetchError,
    });

    const { applyFilterMutate, loading: applyFilterLoad } = useApplyFilterMutation({
        onComplete: onApplyFilterComplete,
        updateTimeFilterFrequency,
    });
    const { applyFilterMutate: applyFilterForFilterB, loading: applyFilterBLoad } = useApplyFilterMutation({
        onComplete: onApplyFilterCompleteFilterB,
    });
    function onApplyFilterCompleteFilterB(payload: any) {
        setIdForRestOfComponentFilterB(payload);
    }

    function isPresetFilterEnabled() {
        if (globalFilterConfig?.presetConfig?.disablePresetFilter) return false;
        return Boolean(
            globalFilterConfig?.presetConfig?.presetEnabledRoutes &&
                ('all' in globalFilterConfig?.presetConfig?.presetEnabledRoutes ||
                    screenName in globalFilterConfig?.presetConfig?.presetEnabledRoutes),
        );
    }

    function markGlobalFilterIdleForPpaHome() {
        globalFilterDeferredRef.current = true;
        setIdForRestOfComponentLoading(false);
        setFilterBLoading(false);
        setLoadingForAllCheckAttribute(false);
        setAllDimAndAttributeType({ dimentions: [], loading: false });
        setAllDimAndAttributeTypeList({ dimentions: [], loading: false });
        setFetchAllAttributeTypesLoading(false);
    }

    function getDefaultScreenConfig(): screenConfig {
        return {
            screenName: screenFilterConfig?.dimensionListKey || 'default',
            globalTimePeriodKey: screenFilterConfig?.getGlobalTimestampsKey || 'default',
            maxTimestampsKey: screenFilterConfig?.getMaxTimestampsKey || 'default',
        };
    }

    useEffect(() => {
        if (isPpaHomeRoute && globalFilterDeferredRef.current) {
            setIdForRestOfComponentLoading(false);
            setFilterBLoading(false);
            return;
        }
        setIdForRestOfComponentLoading(applyFilterLoad);
        setFilterBLoading(applyFilterLoad);
    }, [applyFilterLoad, isPpaHomeRoute]);

    useEffect(() => {
        if (isPpaHomeRoute) {
            setLoadingForAllCheckAttribute(false);
            return;
        }
        setLoadingForAllCheckAttribute(loading || timePeriodFilterLoading);
    }, [loading, timePeriodFilterLoading, isPpaHomeRoute]);

    function setLatestUpdatedDate(dateString: string) {
        setLatestDate(dateString);
    }

    //update the frequency when apply filter call finishes
    function updateTimeFilterFrequency(availableFrequencyKeyArray: string[]) {
        const matchingFrequency: any =
            availableFrequenciesList.find((item: any) => availableFrequencyKeyArray.includes(item.key)) ??
            availableFrequenciesList?.[0];

        const selectedTimeFrequencyList = timePeriodFilterFrequencies?.[matchingFrequency?.key];
        //add custom date at last
        if (selectedTimeFrequencyList?.length) {
            // Add "Custom Date" only if it's not already present
            const hasCustomDate = selectedTimeFrequencyList.some((item: any) => item.timePeriod === 'Custom Date');
            if (!hasCustomDate) {
                selectedTimeFrequencyList.push({
                    timePeriod: 'Custom Date',
                    startTimestamp: 0,
                    endTimestamp: 0,
                });
            }
        }
        setCurrentFrequency(matchingFrequency);
        setAvailableFrequencies(availableFrequencyKeyArray);
        setTimePeriodFilter(selectedTimeFrequencyList);
        //update time period list with default
        updatePeriodList(selectedTimeFrequencyList);
    }

    function onApplyFilterComplete(payload: any) {
        setIdForRestOfComponent(payload);
        if (isPpaPerformanceSummaryRoute) {
            setPpaGlobalFilterApplied(true);
        }
        let rbacDefault = JSON.parse(localStorage.getItem('userAccessScope') || '')?.data_metrics?.data_types;

        functionTOCallAllAttributeName(
            allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType),
            payload,
            { ...presetsFilterObj, ...rbacDefault },
        );
        //check if preset is available
        // if (!selectedPresetInfoObj?.value) {
        //     functionTOCallAllAttributeName(
        //         allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType),
        //         payload,
        //         { ...presetsFilterObj, ...rbacDefault },
        //     );
        // } else allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType);
        //COMMENTED FOR PRESETS
        // setAllSelectedValueForAllAttribute((oldData: any) => {
        //     for (let attrType in oldData) {
        //         if (attrType in globalFilterConfig.promoScoreCardDefault) {
        //             oldData[attrType] = false;
        //         } else {
        //             oldData[attrType] = false;
        //         }
        //     }
        //     return oldData;
        // });
        setAllDimAndAttributeTypeList(allDimAndAttributeType);
        setSinglePresetLoading(false);
        setRecentIdFromAttributeSelection(() => ({
            attr: payload,
        }));
        recentIdFromAttributeSelectionRef.current = {
            attr: payload,
        };
    }

    useEffect(() => {
        if (isPpaHomePath(route.pathname)) {
            markGlobalFilterIdleForPpaHome();
            return;
        }
        resetAndUpdateGlobalFilter(getDefaultScreenConfig());
    }, []);

    //reset global filter
    useEffect(() => {
        const wasPpaHome = isPpaHomePath(previousRouteName.current ?? '');

        //check if preset filter is enabled for current route
        const isPresetEnabledForCurrentRoute = isPresetFilterEnabled();
        if (disablePresetFilter && isPresetEnabledForCurrentRoute) isDefaultPresetFetched.current = false; //reset the preset
        setDisablePresetFilter(!isPresetEnabledForCurrentRoute);

        if (isPpaHomeRoute) {
            markGlobalFilterIdleForPpaHome();
            previousRouteName.current = route.pathname;
            return;
        }

        if (isPpaPerformanceSummaryRoute && previousScreenName !== PPA_PERF_SUMMARY_SCREEN) {
            setPpaGlobalFilterApplied(false);
        }

        // Lazy-init global filter when leaving PPA home if it was never bootstrapped
        if (wasPpaHome && globalFilterDeferredRef.current) {
            globalFilterDeferredRef.current = false;
            resetAndUpdateGlobalFilter(getDefaultScreenConfig());
            previousRouteName.current = route.pathname;
            return;
        }

        //retain filters when moving across different routes
        if (retainFiltersAcrossFeatures) {
            previousApplyFilterObjectRef.current = { ...(applyFilterObject || {}) };
        }

        //check if routes are in same filter group ,
        //if routes are in same group, then dont reset global filter
        const areRoutesInSameGroup =
            globalFilterChangingRoutes?.[previousScreenName]?.groupKey &&
            globalFilterChangingRoutes?.[previousScreenName]?.groupKey ===
                globalFilterChangingRoutes?.[screenName]?.groupKey; //if routes are in same group, then dont reset global filter
        //if current route is pvm or depletion and user navigating to other routes, then reset global filter to default and vice versa
        if (
            globalFilterChangingRoutes &&
            !areRoutesInSameGroup &&
            (screenName in globalFilterChangingRoutes || previousScreenName in globalFilterChangingRoutes)
        ) {
            setCalenderStartDay(screenFilterConfig?.calenderStartDay ?? commonConfig?.calenderStartDay);
            resetAndUpdateGlobalFilter(getDefaultScreenConfig());
        }
        //reset calender start day to default
        if (!(screenName in globalFilterChangingRoutes || previousScreenName in globalFilterChangingRoutes)) {
            setCalenderStartDay(commonConfig?.calenderStartDay);
        }
        previousRouteName.current = route.pathname;
    }, [route.pathname, isPpaHomeRoute]);

    //wrapper function to reset and update global filter
    function resetAndUpdateGlobalFilter(screenConfig: screenConfig) {
        setCurrentFrequency({});
        setAvailableFrequencies([]);
        const { screenName, globalTimePeriodKey, maxTimestampsKey } = screenConfig;
        //reset necessary state to default
        setAttributeTypes({});
        setAllDimAndAttributeTypeList({ dimentions: [], loading: true });
        setAllDimAndAttributeType({ dimentions: [], loading: true });
        //preset
        setPresetsFilterObj(undefined);
        setSelectedPresetInfoObj({ ...initialSelectedPresetInfoObj });

        // get dimension list
        callAllAttributeType({ featureName: screenName });

        //get global timestamps
        fetchTimePeriodFilter({ featureName: globalTimePeriodKey });

        getMaxTimeStampsCall({
            // read this from config
            variables: { frequency: commonConfig.frequency, featureName: maxTimestampsKey },
        });
    }
    // console.log(allDimAndAttributeType, 'logging dim');
    //set attribute types dynamically once data is loaded
    useEffect(() => {
        if (data && 'dimention' in data && Object.keys(data)?.length > data.dimention?.length) {
            setFetchAllAttributeTypesLoading(false);
            const { dimAndAttribute, attributeTypesObj } = dimAndAttributeFormater(data);
            setAllDimAndAttributeType({
                dimentions: dimAndAttribute,
                loading: false,
            });
            setAttributeTypes(attributeTypesObj);
        }
    }, [data]);

    //change loading state in case error is thrown
    useEffect(() => {
        if (fetchAllAttributeTypesError && !loading) {
            setAllDimAndAttributeType({
                ...allDimAndAttributeType,
                loading: false,
            });
        }
    }, [fetchAllAttributeTypesError]);

    const stagePpaScopeInGlobalFilterUi = useCallback(() => {
        if (
            !isPpaPerformanceSummaryRoute ||
            ppaGlobalFilterApplied ||
            !attributeTypes ||
            Object.keys(attributeTypes).length === 0 ||
            !ppaPersistedScope ||
            !hasPersistedUserScope(ppaPersistedScope)
        ) {
            return false;
        }

        const stagedState = buildGlobalFilterUiStateFromPersistedScope(ppaPersistedScope, attributeTypes);
        if (!stagedState) {
            return false;
        }

        const emptyCheckedAttribute = initializeAllSelectedObject(attributeTypes);
        const emptyApplyFilterObject = initializeApplyFilter(attributeTypes);

        setAllCheckedAttribute({
            ...emptyCheckedAttribute,
            ...stagedState.allCheckedAttribute,
        });
        setApplyFilterObject(mergeApplyFilterObjects(emptyApplyFilterObject, stagedState.applyFilterObject));
        setAllSelectedValueForAllAttribute(initializeSelectAllValues(attributeTypes));
        return true;
    }, [attributeTypes, isPpaPerformanceSummaryRoute, ppaGlobalFilterApplied, ppaPersistedScope]);

    const didInitAttributeFilterStateRef = useRef(false);

    // Initialize filter UI state once when attribute types first load.
    useEffect(() => {
        if (!attributeTypes || Object.keys(attributeTypes).length === 0) {
            return;
        }
        if (didInitAttributeFilterStateRef.current) {
            return;
        }
        didInitAttributeFilterStateRef.current = true;

        if (!stagePpaScopeInGlobalFilterUi()) {
            setAllCheckedAttribute(initializeAllSelectedObject(attributeTypes));
            setApplyFilterObject(initializeApplyFilter(attributeTypes));
            setAllSelectedValueForAllAttribute(initializeSelectAllValues(attributeTypes));
        }
    }, [attributeTypes, stagePpaScopeInGlobalFilterUi]);

    // Stage inherited scope into the filter UI when scope arrives or after reset.
    useEffect(() => {
        if (ppaGlobalFilterApplied) {
            return;
        }
        stagePpaScopeInGlobalFilterUi();
    }, [ppaPersistedScope, ppaGlobalFilterApplied, stagePpaScopeInGlobalFilterUi]);

    const dimList = attributeTypes ? Object.keys(attributeTypes) : [];

    const screenHistory = useRef<any[]>([]);

    //check if different time period exists for different screens
    useEffect(() => {
        if (currentFrequency && Object.keys(currentFrequency)?.length > 0 && timePeriodFilter?.length > 0) {
            const previousScreenName = screenHistory.current?.[screenHistory.current.length - 1] || '';
            const secondPreviousScreenName = screenHistory.current?.[screenHistory.current.length - 2] || '';
            const timePeriodCurrentMapping = globalFilterConfig?.timePeriodScreenMapping?.[screenName];
            const timePeriodPreviousMapping = globalFilterConfig?.timePeriodScreenMapping?.[previousScreenName];
            const timePeriodSecondPreviousMapping =
                globalFilterConfig?.timePeriodScreenMapping?.[secondPreviousScreenName];
            screenHistory.current.push(screenName);
            if (
                timePeriodCurrentMapping ||
                timePeriodPreviousMapping ||
                timePeriodSecondPreviousMapping ||
                !timePeriodList?.length
            ) {
                const periodList = changePeriodAccordingToScreen(screenName, timePeriodFilter, globalFilterConfig);
                setTimePeriodList(periodList);
                //updatePeriodList();
                checkIfTimePeriodExistsAndUpdate(timeSelectionLabel, periodList);
            }
        }
    }, [timePeriodFilter, currentFrequency, route.pathname]);

    //on changing route, check if selected time period filter is present in time period list,
    // if not set 1st item from time period list as time period filter
    function checkIfTimePeriodExistsAndUpdate(timeSelectionLabel: string, periodList: any[]) {
        const defaultSelectedTimePeriod = periodList?.filter(
            (time: any) => time.timePeriod?.toLowerCase() === String(timeSelectionLabel)?.toLowerCase(),
        )[0];
        //if time period not present in list, then update time period by 1st item from list
        if (!defaultSelectedTimePeriod) {
            setTimePeriodSelection(
                JSON.stringify({
                    start_timestamp: periodList?.[0]?.startTimestamp,
                    end_timestamp: periodList?.[0]?.endTimestamp,
                }),
            );
            setTimeSelectionLabel(periodList?.[0]?.timePeriod);
        }
    }

    const updatePeriodList = (timePeriodFilter: any[]) => {
        const periodList = changePeriodAccordingToScreen(screenName, timePeriodFilter, globalFilterConfig);
        const defaultSelectedTimePeriod =
            periodList?.find((time: any) =>
                globalFilterConfig?.defaultPeriod?.includes(time.timePeriod?.toUpperCase()),
            ) || periodList?.[0];
        // apply default time period
        if (defaultSelectedTimePeriod) {
            setTimePeriodSelection(
                JSON.stringify({
                    start_timestamp: defaultSelectedTimePeriod.startTimestamp,
                    end_timestamp: defaultSelectedTimePeriod.endTimestamp,
                }),
            );
            setTimeSelectionLabel(defaultSelectedTimePeriod.timePeriod?.toUpperCase());
        }
    };

    //parse time period from presets
    function parseTimePeriod(timePeriodObj: any) {
        //getting current period list from config
        const periodList = changePeriodAccordingToScreen(screenName, timePeriodFilter, globalFilterConfig);
        let periodObj = periodList?.filter(
            (time: any) => time.timePeriod?.toLowerCase() === timePeriodObj?.timeSelectionLabel?.toLowerCase(),
        )[0];
        if (periodObj?.timePeriod?.toLowerCase() === 'custom date') {
            const parsedDatObj = JSON.parse(timePeriodObj?.timePeriodSelection);
            periodObj.startTimestamp = parsedDatObj?.start_timestamp;
            periodObj.endTimestamp = parsedDatObj?.end_timestamp;
        }
        //if preset time period exists in period list, use that else use first item from period list
        const tempTimeSelectionLabel = periodObj ? periodObj?.timePeriod : periodList?.[0]?.timePeriod;
        const tempTimePeriodSelection = JSON.stringify({
            start_timestamp: periodObj ? periodObj?.startTimestamp : periodList?.[0]?.startTimestamp,
            end_timestamp: periodObj ? periodObj?.endTimestamp : periodList?.[0]?.endTimestamp,
        });
        setVisibleDatePicker(timePeriodObj?.timeSelectionLabel?.toLowerCase() === 'custom date');
        setTimePeriodSelection(tempTimePeriodSelection);
        setTimeSelectionLabel(tempTimeSelectionLabel);
    }

    //wrapper function for fetching single preset
    function fetchSinglePresetWrapper(variables: any = {}, options: { isReset?: boolean } = {}) {
        if (options.isReset) {
            previousApplyFilterObjectRef.current = {};
        }
        const userEmail = localStorage.getItem('email');
        if (!userEmail)
            return sendNotification('error', 'Please login to the application again to perform this action.');
        const disablePresetFilter = !isPresetFilterEnabled();
        const skipPresetCall = Object.keys(variables).length === 0 && isDefaultPresetFetched.current;

        //if preset filter is disabled or screen level config is present then load with default filter
        //if this is true, then default preset is already fetched
        //dont fetch preset again if default preset call is already triggered before irrespective of its status
        if (disablePresetFilter || skipPresetCall) {
            onPresetFetchError();
            return;
        }

        if (!isDefaultPresetFetched.current) isDefaultPresetFetched.current = true;
        fetchSinglePreset({
            variables: {
                userEmail,
                defaultFlag: true,
                presetFilterName: '',
                ...variables,
            },
        });
    }

    //called when preset fetch throws an error
    //set all global filter variables to default
    function onPresetFetchError() {
        //if retain filters is true, then consider previous apply filter object
        const defaultFilter =
            Object.keys(previousApplyFilterObjectRef.current).length > 0
                ? previousApplyFilterObjectRef.current
                : defaultGlobalFilterFromConfig;
        setPresetsFilterObj({ ...defaultFilter });
        setAllCheckedAttribute(initializeAllSelectedObject(attributeTypes));
        setAllSelectedValueForAllAttribute((oldData: any) => {
            for (let attrType in oldData) {
                oldData[attrType] = false;
            }
            return oldData;
        });
        setApplyFilterObject(initializeApplyFilter(attributeTypes));

        setSinglePresetLoading(false);
        setSelectedPresetInfoObj({ ...initialSelectedPresetInfoObj });
    }

    //called when single preset fetch is complete
    function onPresetFetchComplete(stringifiedPresentFilter: any) {
        // Backend returns null when the user has no default preset (a normal first-time state).
        // Treat this as a silent fallback to default filters rather than an error.
        if (!stringifiedPresentFilter?.presetFilter) {
            onPresetFetchError();
            return;
        }
        try {
            const { filterObj, timePeriodFilterObj } = JSON.parse(stringifiedPresentFilter.presetFilter);
            //for global filter except time period
            setApplyFilterObject(filterObj?.applyFilterObject);
            setAllCheckedAttribute(filterObj?.allCheckedAttribute);
            setAllSelectedValueForAllAttribute(filterObj?.allSelectedValueForAllAttribute);
            setPresetsFilterObj(createDefaultFilterObject(filterObj?.applyFilterObject));

            //for time period
            parseTimePeriod(timePeriodFilterObj);

            //preset name and is default
            setSelectedPresetInfoObj({
                label: stringifiedPresentFilter?.defaultFlag
                    ? `${stringifiedPresentFilter?.presetFilterName} (Default)`
                    : stringifiedPresentFilter?.presetFilterName,
                value: stringifiedPresentFilter?.presetFilterName,
                isDefault: stringifiedPresentFilter?.defaultFlag,
            });
            sendNotification('success', 'Preset loaded successfully.');
        } catch (error) {
            onPresetFetchError();
            console.log(error, 'logging error');
        }
    }

    // apply global filters, except time period
    function applyGlobalFilterHandler(stringifiedPresentFilter: any) {
        const { filterObj } = JSON.parse(stringifiedPresentFilter);
        try {
            setApplyFilterObject(filterObj?.applyFilterObject);
            setAllCheckedAttribute(filterObj?.allCheckedAttribute);
            setAllSelectedValueForAllAttribute(filterObj?.allSelectedValueForAllAttribute);
            setPresetsFilterObj(createDefaultFilterObject(filterObj?.applyFilterObject));
        } catch (error) {
            console.log(error, 'logging error');
        }
    }

    useEffect(() => {
        if (isPpaHomeRoute || isPpaPerformanceSummaryRoute) {
            return;
        }
        if (attributeTypes && Object.keys(attributeTypes).length > 0) {
            fetchSinglePresetWrapper({});
        }
    }, [attributeTypes, isPpaHomeRoute, isPpaPerformanceSummaryRoute]);

    useEffect(() => {
        if (!isPpaPerformanceSummaryRoute) {
            return;
        }
        if (!ppaScopeFilterLoading && !allDimAndAttributeType.loading) {
            setIdForRestOfComponentLoading(false);
            setSinglePresetLoading(false);
        }
    }, [isPpaPerformanceSummaryRoute, ppaScopeFilterLoading, allDimAndAttributeType.loading]);

    //Dim and Attribute Type
    useEffect(() => {
        if (isPpaHomeRoute || isPpaPerformanceSummaryRoute) {
            return;
        }
        if (
            !allDimAndAttributeType.loading &&
            allDimAndAttributeType.dimentions &&
            presetsFilterObj &&
            Object.keys(timePeriodFilterFrequencies ?? {})?.length > 0
        ) {
            initialize(
                applyFilterObject,
                presetsFilterObj,
                applyFilterObjectAdd,
                setApplyFilterObject,
                getApplyFilterObject,
                callId,
                applyFilterMutate,
                promoScoreCardConfig,
                getFilteredApplyFilterObject,
                createFilterB,
                applyFilterForFilterB,
                // screenName === 'promo-score-card',
                true,
            );
        }
    }, [
        allDimAndAttributeType,
        presetsFilterObj,
        timePeriodFilterFrequencies,
        isPpaHomeRoute,
        isPpaPerformanceSummaryRoute,
    ]);

    const memoisedDimAndAttributeList = useMemo(() => {
        return {
            dimentions: allDimAndAttributeTypeList.dimentions,
            loading: allDimAndAttributeTypeList.loading || singlePresetFetchLoading,
        };
    }, [allDimAndAttributeTypeList, singlePresetFetchLoading]);

    const state = {
        allDimAndAttributeType,
        setAllDimAndAttributeType,
        allAttributeNames,
        setAllAttributeNames,
        allCheckedAttribute,
        setAllCheckedAttribute,
        recentIdFromAttributeSelection,
        setRecentIdFromAttributeSelection,
        applyFilterButtonObject,
        idForRestOfComponent,
        setIdForRestOfComponent,
        previousSelectedAttributesInUI,
        setPreviousSelectedAttributesInUI,
        allDimAndAttributeTypeList: memoisedDimAndAttributeList,
        setAllDimAndAttributeTypeList,
        applyFilterObject,
        setApplyFilterObject,
        allSelectedValueForAllAttribute,
        setAllSelectedValueForAllAttribute,
        timePeriodSelection,
        setTimePeriodSelection,
        idForRestOfComponentLoading,
        setIdForRestOfComponentLoading,
        ppaScopeFilterLoading,
        setPpaScopeFilterLoading,
        ppaScopeFilterIds,
        setPpaScopeFilterIds,
        ppaGlobalFilterApplied,
        setPpaGlobalFilterApplied,
        ppaPersistedScope,
        setPpaPersistedScope,
        idForRestOfComponentFilterB,
        setIdForRestOfComponentFilterB,
        loadingForAllCheckAttribute,
        setLoadingForAllCheckAttribute,
        timePeriodLoading: timePeriodFilterLoading,
        recentIdFromAttributeSelectionRef,
        timePeriodList,
        filterNullError,
        setFilterNullError,
        filterBLoading,
        setFilterBLoading,
        setTimePeriodList,
        timeSelectionLabel,
        setTimeSelectionLabel,
        setLatestUpdatedDate,
        latestDate,
        visibleDatePicker,
        setVisibleDatePicker,
        expandFilterBol,
        setExpandFilterBol,
        presetsFilterObj,
        selectedPresetInfoObj,
        setSelectedPresetInfoObj,
        fetchSinglePresetWrapper,
        applyGlobalFilterHandler,
        isGlobalFilterDisabled,
        setIsGlobalFilterDisabled,
        attributeTypes,
        screenFilterConfig,
        maxTimeStampData,
        maxTimeStampLoading,
        maxTimeStampError,
        screenName,
        hideGlobalTimeFilterComponent,
        setHideGlobalTimeFilterComponent,
        disablePresetFilter,
        currentFrequency,
        calenderStartDay,
        availableFrequencies,
        showTierFilter,
        multiSelectedTiers,
        setMultiSelectedTiers,
        singleSelectedTier,
        setSingleSelectedTier,
        profitPoolTierList,
        isTiersSingleSelect,
        setIsTiersSingleSelect,
        tempMultiSelectedTiers,
        setTempMultiSelectedTiers,
        tempSingleSelectedTier,
        setTempSingleSelectedTier,
        closeTierFilter,
        setCloseTierFilter,
        isGlobalFilterCollapsed,
        setIsGlobalFilterCollapsed,
    };
    return <FilterContextData.Provider value={state}>{children}</FilterContextData.Provider>;
};
export { FilterContext, FilterContextData };
